import {FC} from "react"
import {HttpService} from "../../service/HttpService"
import {Custom} from "../Custom"
import Contacts from "./Contacts";


export const ContactsPage: FC = () => {
  const customProject = HttpService?.customProject

  return (
      <>
        {
          customProject?.customFrontend && customProject?.frontendComponents?.some(component => component?.pathUrl === "/contacts-custom")
              ? <Custom customFrontendUrl={customProject?.customFrontendUrl}
                        type={customProject?.frontendComponents?.find(comp => comp?.pathUrl === "/contacts-custom")?.component}
              />
              :
              <Contacts />
        }
      </>
  )
}